















































































































































import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Watch } from 'vue-property-decorator';
import { UserPrefsActions } from '@/store/userPrefs/actions';
import { UserActions } from '@/store/users/actions';
import { DetailedUserData } from '@/store/users/types';
import { AdminActions } from '@/store/admin/actions';

const userPrefsModule = namespace('userPrefs');
const userModule = namespace('users');
const adminModule = namespace('admin');

@Component
export default class Profile extends Vue {
  @userPrefsModule.State('hudEnabled') hudEnabled: boolean;

  @userPrefsModule.State('displayImperial') displayImperial: boolean;

  @userPrefsModule.State('useZoomFilter') useZoomFilter: boolean;

  @userPrefsModule.State('useDefectCodeDesc') useDefectCodeDesc: boolean;

  @userModule.State('allDetailedUserData') allUsers: DetailedUserData[];

  @userModule.State('loading') userLoading: boolean;

  @adminModule.State('loading') adminLoading: boolean;

  @userPrefsModule.Action(UserPrefsActions.SET_HUD_ENABLED) setHUDEnabled;

  @userPrefsModule.Action(UserPrefsActions.SET_METRIC_PREFS) setMetricPrefs;

  @userPrefsModule.Action(UserPrefsActions.SET_ZOOM_FILTER) setZoomFilter;

  @userPrefsModule.Action(UserPrefsActions.SET_DEFECT_CODEDESC)
  setDefectCodeDesc;

  @userModule.Action(UserActions.FETCH_ALL_DETAILED_USER_DATA)
  fetchAllDetailedUserData;

  @adminModule.Action(AdminActions.PATCH_USER) patchUser;

  baseURI = window.location.origin;

  isEditing = false;

  userNameEdit = '';

  userNicknameEdit = '';

  nasscoIdEdit = '';

  nasscoIdPattern = /(^U[0-9]*$)|(^P[0-9]*$)/;

  displayImperialModel = true;

  hudEnabledModel = false;

  useZoomFilterModel = false;

  useDefectCodeDescModel = false;

  @Watch('userDetails')
  onUserDetailChange(): void {
    this.userNameEdit = `${this.userDetails.firstname} ${this.userDetails.lastname}`;
    this.userNicknameEdit = this.userDetails.nickname;
    this.nasscoIdEdit = this.userDetails.nasscoid;
  }

  @Watch('hudEnabled')
  @Watch('displayImperial')
  @Watch('useZoomFilter')
  @Watch('useDefectCodeDesc', { immediate: true })
  onUserPrefStoreChange(): void {
    this.hudEnabledModel = this.hudEnabled;
    this.displayImperialModel = this.displayImperial;
    this.useZoomFilterModel = this.useZoomFilter;
    this.useDefectCodeDescModel = this.useDefectCodeDesc;
  }

  get userDetails(): DetailedUserData {
    let user = null;

    if (this.allUsers) {
      user = this.allUsers.find(
        (u) => u.useridentity && u.useridentity.includes(this.$auth.user.id),
      );
    }

    return user;
  }

  get loading(): boolean {
    return this.userLoading || this.adminLoading;
  }

  mounted(): void {
    if (!this.allUsers) this.fetchAllDetailedUserData();
  }

  async saveEdit(): Promise<void> {
    const userEdit = {
      Guid: this.userDetails.guid,
      Firstname: this.userNameEdit.split(' ')[0],
      Lastname: this.userNameEdit.split(' ')[1],
      nickname: this.userNicknameEdit,
      userRoleObjects: this.userDetails.role,
      nasscoId: this.nasscoIdEdit,
    };

    await this.patchUser(userEdit);
    this.$forceUpdate();
    this.isEditing = false;
  }

  cancelEdit(): void {
    this.isEditing = false;
    this.userNameEdit = `${this.userDetails.firstname} ${this.userDetails.lastname}`;
    this.userNicknameEdit = this.userDetails.nickname;
    this.nasscoIdEdit = this.userDetails.nasscoid;
  }
}
